export default "__VITE_ASSET__CpYHQmgR__"